import React from "react";
import { Box, Flex, Text, Button } from "@chakra-ui/react";
import { ArrowForwardIcon, CheckCircleIcon, WarningIcon, InfoIcon } from "@chakra-ui/icons";

const getFeedback = (result) => {
  if (!result || !result.max) {
    return {
      status: "info",
      title: "Answer submitted",
      message: "Compare your answer with the solution below.",
    };
  }
  if (result.earned >= result.max) {
    return { status: "correct", title: "Correct!", message: "Nice work, you got it right." };
  }
  if (result.earned > 0) {
    return {
      status: "partial",
      title: "Partially correct",
      message: "Some parts are right. Check the highlighted answers below.",
    };
  }
  return {
    status: "incorrect",
    title: "Not quite",
    message: "Check the correct answer below, or ask Ninja to explain it.",
  };
};

const STYLES = {
  correct: { bg: "#e8f7ef", border: "#29b473", color: "#1b7a4d", Icon: CheckCircleIcon },
  partial: { bg: "#fff6e0", border: "#f0a500", color: "#8a5d00", Icon: WarningIcon },
  incorrect: { bg: "#fdecec", border: "#e04848", color: "#a32929", Icon: WarningIcon },
  info: { bg: "#e1f3ff", border: "#1c72c9", color: "#11599e", Icon: InfoIcon },
};

// Shown in Learn mode right after a question is submitted, above the graded question.
export const LearnFeedback = ({ result, isLastQuestion, onNext }) => {
  const { status, title, message } = getFeedback(result);
  const { bg, border, color, Icon } = STYLES[status];
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        maxWidth: "1180px",
        margin: "12px auto",
        padding: "14px 18px",
        background: bg,
        borderLeft: `5px solid ${border}`,
        borderRadius: "12px",
      }}
    >
      <Flex alignItems="center" justifyContent="space-between" gap="4" flexWrap="wrap">
        <Flex alignItems="center" gap="3">
          <Icon color={border} boxSize="28px" />
          <Box>
            <Text fontWeight="700" fontSize="lg" color={color}>
              {title}
              {!!result?.max && (
                <Text as="span" fontWeight="600" fontSize="md" marginLeft="8px">
                  ({result.earned}/{result.max} points)
                </Text>
              )}
            </Text>
            <Text fontSize="sm" color={color}>{message}</Text>
          </Box>
        </Flex>
        <Button colorScheme="brand" rightIcon={<ArrowForwardIcon />} onClick={onNext}>
          {isLastQuestion ? "See Report" : "Next Question"}
        </Button>
      </Flex>
    </Box>
  );
};
